import {
  ChangeDetectionStrategy,
  Component,
  computed,
  Inject,
} from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { TuiAvatarModule } from '@taiga-ui/kit';
import {
  TuiButtonModule,
  TuiDataListModule,
  TuiHostedDropdownModule,
  TuiSvgModule,
} from '@taiga-ui/core';
import { AuthState } from '@store/auth/auth.state';
import { Store } from '@ngxs/store';
import { tuiIconChevronDown } from '@taiga-ui/icons';
import { WINDOW } from '@shared/providers/window.provider';
import { TranslocoPipe } from '@jsverse/transloco';
import { PermissionService } from '@shared/services/permission.service';
import { DROPDOWN_MENU_ITEMS, MenuItem } from '../../menu';
import { OrganizationRouteNames } from '../../../../route-names';

@Component({
  selector: 'app-dropdown-menu',
  standalone: true,
  imports: [
    RouterLink,
    TuiAvatarModule,
    TuiDataListModule,
    TuiHostedDropdownModule,
    TuiSvgModule,
    TuiButtonModule,
    TranslocoPipe,
  ],
  templateUrl: './dropdown-menu.component.html',
  styleUrl: './dropdown-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownMenuComponent {
  isAuthenticated = this.store.selectSignal(AuthState.isAuthenticated);

  availableMenuItems = computed(() => {
    return DROPDOWN_MENU_ITEMS.filter(menuItem => {
      if (menuItem?.authenticated) {
        return this.isAuthenticated();
      }
      return true;
    }).filter(menuItem => {
      return menuItem.permission
        ? this.permissionService.hasAuthority(menuItem.permission)
        : true;
    });
  });

  protected readonly tuiIconChevronDown = tuiIconChevronDown;
  constructor(
    @Inject(WINDOW) private readonly window: Window,
    private readonly store: Store,
    private readonly router: Router,
    private readonly permissionService: PermissionService,
  ) {}

  navigate(route: MenuItem) {
    if (route.path === OrganizationRouteNames.DETAILS) {
      const divisionId = this.store.selectSnapshot(
        AuthState.getActiveDivisionId,
      );
      if (divisionId) {
        const path = route.path.replace(':id', divisionId.toString());
        return this.router.navigate([path]);
      }
      return;
    }
    return this.router.navigate([route.path]);
  }
}
